import React from 'react';

function Experiences() {
    return (
        <>

            {/* <!-- Header Banner --> */}
            <section className="banner-header bg-img bg-fixed" data-overlay-dark="5" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/img/banner/20.jpg)` }}>
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="subtitle">Black Rock Luxury Hotel</div>
                            <div className="title">Experiences</div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Experiences */}
            <section className="exp-section">
                <div className="container">
                    <div className="exp-header">
                        <div className="exp-header__label">What awaits you</div>
                        <h2 className="exp-header__title">Experiences & Activities</h2>
                        <div className="exp-header__divider" />
                    </div>
                    <div className="exp-grid">
                        {[
                            { icon: 'fa-person-hiking',      num: '01', title: 'Activities',          desc: 'Horse rides, hikes, and nature meditation — your nomadic journey starts here.' },
                            { icon: 'fa-map-location-dot',   num: '02', title: 'Nearby Attractions',  desc: 'Explore hidden valleys, sacred peaks, and rich culture — made for true explorers.' },
                            { icon: 'fa-people-group',       num: '03', title: 'Events & Meetings',   desc: 'Host your event in style — ideal for intimate gatherings or corporate retreats.' },
                            { icon: 'fa-images',             num: '04', title: 'Photo Gallery',       desc: 'Step into our world — browse moments that speak louder than words.' },
                            { icon: 'fa-utensils',           num: '05', title: 'Culinary',            desc: 'Enjoy local and global flavors, thoughtfully crafted and beautifully served.' },
                        ].map((item) => (
                            <div key={item.num} className="exp-card">
                                <div className="exp-card__num">{item.num}</div>
                                <div className="exp-card__icon">
                                    <i className={`fa-thin ${item.icon}`}></i>
                                </div>
                                <div className="exp-card__divider" />
                                <h5 className="exp-card__title">{item.title}</h5>
                                <p className="exp-card__desc">{item.desc}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </>
    );
}

export default Experiences;